export default __webpack_public_path__ + "static/bagisto-06fa78ee9d0757e6c82847b60a64e844.png";